import {SidebarPageLayout, type SidebarPageLayoutContentProps} from '@github-ui/layout-primitives/SidebarPageLayout'
import type {PropsWithChildren} from 'react'

import styles from './AgentsCustomizePage.module.css'

export function AgentsCustomizePageContent({children, ...props}: PropsWithChildren<SidebarPageLayoutContentProps>) {
  return (
    <SidebarPageLayout.Content as="div" className={styles.content} {...props}>
      <SidebarPageLayout.SidebarTrigger />
      {children}
    </SidebarPageLayout.Content>
  )
}
